import React, { Component } from 'react';
import DetectRadioItem from './item';
import './index.scss';

export default class DetectRadio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    });

    if (this.props.onChange) {
      this.props.onChange(e.target.value);
    }
  }

  render() {
    const {
      name,
      desc,
      options
    } = this.props;
    return (
      <div className="detect-radio-group">
        {
          options.map(item => (
            <DetectRadioItem
              key={item.value}
              name={name}
              checked={this.state.value === item.value}
              {...item}
              onChange={this.onChange}
            />
          ))
        }
        <div className="detect-radio-group-desc">{desc}</div>
      </div>
    );
  }
}
